import React, { useContext, useState, useEffect, useRef, useCallback } from "react";
import WaveSurfer from "wavesurfer.js";
import AudioPlayer from "react-h5-audio-player";
import SidebarContext from "../../contexts/MyContext";
import { enablePushNotifications } from "../../utils/pushNotification";
import { truncateFileName } from "../../utils/truncateFileName";
import useDownloader from "react-use-downloader";
import { AudioHandler } from "../../Apihander/AudioRecording/AudioRecording";
import { formatTimeWithOptionalHours, timeStringToSeconds, durationToSeconds } from '../../utils/timeFile'
import { TRANSCRIBE_MAX_DURATION } from '../../utils/transcribeUtils'
import { Icon } from "@iconify/react";
import "../Waveform/WaveForm.css";
import Loader from "../../animations/Loader";
import ActionButton from "./ActionButton";
import AudioNote, { audioNotes } from "./AudioNote";
import { Ic, noteSeconds, recordingSeconds, withNotes } from "../../pages/Notes/notesShared";
import { useNavigate } from "react-router-dom";
import { useTrackNavigation } from "../../utils/trackNavigationUtils";
import Modal from "../Modal/Modal";
import { errorToast, successToast } from "../../utils/notificationUtils";
import { destroyWavesurfer, loadWavesurfer } from "../../utils/wavesurferUtils";

const SelectRecordPlay = ({ startRecording, elapsedTime }) => {
    const {
        audio,
        tabIndex,
        setAudio,
        audioIndex,
        setAudioIndex,
        folderAudioIndex,
        setFolderAudioIndex,
        setTabIndex,
        audioData,
        setSelectedTrimAudio,
        setSelectedAdjustAudio,
        setSelectMergeAudio,
        setSelectedConvertAudio,
        setSelectedTranscriptAudio,
        filterAudioData,
        listTabIndex,
        favoriteAudio,
        setFavoriteAudio,
        actionTabIndex,
        setActionTabIndex,
        textAreaContent,
        setTextAreaContent,
        isUpdateTranscribe,
        setIsUpdateTranscribe,
        setFilterAudioData,
        setRecordNew,
        setIsRecordingStarted,
        setActionType, setPendingIndex,
        transcribeStartingIds, setTranscribeStartingIds,
        transcribeInProgressIds, setTranscribeInProgressIds,
        handoffAudioId, setHandoffAudioId,
        setSelectedAudioId,
        setIsAudioPlaying,
        setAutoStartRecording,
        setRecordingFolderId
    } = useContext(SidebarContext);

    const { isPrevDisabled, isNextDisabled, playPreviousTrack, playNextTrack, handleUnsupportedFile } = useTrackNavigation()
    // const { handleUnsupportedFile, } = useTrackNavigation()

    const [isDownloading, setIsDownloading] = useState(false);
    const [timeFormat, setTimeFormat] = useState("mm:ss");
    const [duration, setDuration] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [currentTime, setCurrentTime] = useState(0);
    const isFolderAudio = audio?.isFolder;
    const [audioBlobUrl, setAudioBlobUrl] = useState(null);
    const [volume, setVolume] = useState(1);
    // const [transcribeLoading, setTranscribeLoading] = useState(false);
    const [isCurrentUser, setIsCurrentUser] = useState()
    const wavesurfer = useRef(null);
    const seekbarRef = useRef(null);
    const animationRef = useRef(null);
    const currentTimeRef = useRef(0);
    const durationRef = useRef(0);
    const navigate = useNavigate();
    const [transcribeModal, setTranscribeModal] = useState(false)
    // Lets a finished start request tell whether its audio is still the one on screen.
    const currentAudioIdRef = useRef(audio?._id);
    currentAudioIdRef.current = audio?._id;

    // Only the audio whose start request is in flight shows the spinner.
    const transcribeLoading = !!audio?._id && transcribeStartingIds.includes(audio._id);

    // A job started here, or one the backend is still running, keeps Transcript disabled.
    const isTranscribeInProgress = !!audio?._id
        && !audio?.transcribe?.isTranscribe
        && (transcribeInProgressIds.includes(audio._id) || audio?.transcribe?.status === 'processing');




    const { download, isInProgress, percentCompleted } = useDownloader(
        // { mode: 'no-cors', }
    )


    const updateSeekbar = useCallback(() => {
        if (wavesurfer.current && seekbarRef.current) {
            const currentTime = wavesurfer.current.getCurrentTime();
            const duration = wavesurfer.current?.getDuration();

            setCurrentTime(currentTime);
            setDuration(duration);

            let progress = 0;
            if (duration > 0) {
                progress = (currentTime / duration) * 100;
            }

            seekbarRef.current.value = progress;
            seekbarRef.current.style.setProperty('--seek-before-width', `${progress}%`);

            animationRef.current = requestAnimationFrame(updateSeekbar);

        }
    }, []);

    // // Play next track based on whether the current audio is folder audio or not
    // const playNextTrack = () => {
    //     const list = listTabIndex === 1 ? filterAudioData : favoriteAudio;
    //     let nextIndex = audioIndex + 1;
    //     // while (nextIndex < list.length) {

    //     const fileExtension = list[nextIndex]?.audio?.fileName.split('.').pop().toLowerCase();

    //     debugger

    //     if (fileExtension === "caf" || fileExtension === "m4a") {
    //         debugger
    //         console.log("21212121", fileExtension);
    //         handleUnsupportedFile();
    //         // setAudioIndex(prevIndex => prevIndex)
    //         setActionType("next");
    //         setPendingIndex(nextIndex);
    //         setAudioIndex(nextIndex)

    //     } else {

    //         if (listTabIndex == 1 ? filterAudioData?.length : favoriteAudio?.length - 1) {
    //             setAudioIndex(prevIndex => prevIndex + 1);
    //         }
    //     }
    //     // }

    // };

    // // Play previous track based on whether the current audio is folder audio or not
    // const playPreviousTrack = () => {
    //     // console.log(audioIndex > 0 ? true : false)
    //     if (audioIndex > 0) {
    //         setAudioIndex(prevIndex => prevIndex - 1);
    //     }
    // };


    // const isPrevDisabled = audioIndex <= 0;
    // const isNextDisabled = (listTabIndex == 1 && audioIndex == filterAudioData?.length - 1) || (listTabIndex == 2 && audioIndex == favoriteAudio?.length - 1);



    // Update the audio source when the index changes
    useEffect(() => {
        if (audio) {
            listTabIndex === 1 ? (

                setAudio(filterAudioData[audioIndex])
            ) : (
                setAudio(favoriteAudio[audioIndex])
            )

        }
    }, [audioIndex, filterAudioData, favoriteAudio, audio, listTabIndex]);

    // const playPause = () => {
    //     if (wavesurfer.current) {
    //         wavesurfer.current.playPause();
    //     }
    // };

    // const handleSkip = (direction) => {
    //     if (wavesurfer.current) {
    //         const currentTime = wavesurfer.current.getCurrentTime();
    //         const duration = wavesurfer.current.getDuration();
    //         const newTime = direction === 'forward' ? currentTime + 5 : currentTime - 5;
    //         wavesurfer.current.seekTo(Math.max(0, Math.min(1, newTime / duration)));
    //     }
    // };

    // const handleSeekbarChange = (e) => {
    //     const seekTo = parseFloat(e.target.value) / 100;
    //     if (wavesurfer.current) {
    //         wavesurfer.current.seekTo(seekTo);
    //     }
    // };


    useEffect(() => {
        let timeoutId;

        if (audio?.audio?.url) {
            const fileExtension = audio?.audio?.fileName?.split('.').pop().toLowerCase()
            setIsLoading(true);
            // Cleared here so a switch never leaves the previous recording's time on the seekbar
            setDuration(0);
            setCurrentTime(0);
            if (seekbarRef.current) {
                seekbarRef.current.value = 0;
                seekbarRef.current.style.setProperty('--seek-before-width', '0%');
            }
            timeoutId = setTimeout(() => {
                destroyWavesurfer(wavesurfer.current);
                wavesurfer.current = null;

                wavesurfer.current = WaveSurfer.create({
                    container: document.createElement('div'),
                    backend: 'WebAudio',
                    normalize: true,
                    responsive: true,
                });

                if (fileExtension === "caf" || fileExtension === "m4a") {


                    seekbarRef.current.value = 0
                    seekbarRef.current.style.setProperty('--seek-before-width', `${0}%`);
                    seekbarRef.current.style.setProperty('background', `linear-gradient(
    to right,
    #334155 0%,
    #334155 0%,
    #dddddd 0%,
    #dddddd 100%
  )`);

                } else {

                    loadWavesurfer(wavesurfer.current, audio?.audio?.url);
                }


                wavesurfer.current.on('ready', () => {
                    setIsLoading(false);
                    setDuration(wavesurfer.current?.getDuration());
                    // play() rejects if the instance is torn down mid-start
                    Promise.resolve(wavesurfer.current?.play()).catch(() => { });
                    setIsPlaying(true);
                    updateSeekbar();
                });

                wavesurfer.current.on('play', () => {
                    setIsPlaying(true);
                    animationRef.current = requestAnimationFrame(updateSeekbar);
                });

                wavesurfer.current.on('pause', () => {
                    setIsPlaying(false);
                    cancelAnimationFrame(animationRef.current);
                });

                wavesurfer.current.on('finish', () => {
                    setIsPlaying(false);
                    cancelAnimationFrame(animationRef.current);
                    // Ensure the progress bar reaches 100% at the end of the audio
                    if (seekbarRef.current) {
                        seekbarRef.current.value = 100;
                        seekbarRef.current.style.setProperty('--seek-before-width', `100%`);
                    }
                });

            }, 300); // 300ms delay to avoid fast switching issues

            return () => {
                clearTimeout(timeoutId);
                cancelAnimationFrame(animationRef.current);
                destroyWavesurfer(wavesurfer.current);
                wavesurfer.current = null; // Ensure it's reset after destroy
            };
        }
        // Keyed on the id too, so two recordings sharing a url still reload
    }, [audio?._id, audio?.audio?.url]);

    // Mirror the play state into context so the recording lists can flag the playing row.
    useEffect(() => {
        setIsAudioPlaying(!!audio?.audio?.url && isPlaying);
    }, [isPlaying, audio?.audio?.url, setIsAudioPlaying]);

    useEffect(() => () => setIsAudioPlaying(false), [setIsAudioPlaying]);

    useEffect(() => {
        const userData = localStorage.getItem("currentUser");

        const convertedUserData = JSON.parse(userData)
        setIsCurrentUser(convertedUserData)
    }, []);




    const playPause = () => {
        if (wavesurfer.current && !isLoading) {
            wavesurfer.current.playPause();
        }
    };

    const handleSkip = (direction) => {
        if (wavesurfer.current) {
            const currentTime = wavesurfer.current.getCurrentTime();
            const duration = wavesurfer.current.getDuration();
            const newTime = direction === 'forward' ? currentTime + 5 : currentTime - 5;
            wavesurfer.current.seekTo(Math.max(0, Math.min(1, newTime / duration)));
        }
    };

    const handleSeekbarChange = (e) => {
        const seekTo = parseFloat(e.target.value) / 100;
        if (wavesurfer.current) {
            wavesurfer.current.seekTo(seekTo);
        }
    };



    function doHandleDownloadingResourceAllocation(content, contentType = 'audio/mpeg') {

        const fileName = audio?.audio?.fileName || 'downloaded_audio.mp3'; // Ensure there's a valid file name
        const blob = new Blob([content]);

        const a = document.createElement("a");
        a.href = window.URL.createObjectURL(blob);
        a.download = fileName;
        a.click();

        setTimeout(() => {
            setIsDownloading(false);
        }, 2000); // Wait for 2 seconds to simulate download start
    }

    // const handleDownloadClick = async (e) => {
    //     e.preventDefault();
    //     const audioId = audio?._id; // Assuming audioId is part of the audio object
    //     if (!audioId) {
    //         console.error("Invalid audio ID", { audioId });
    //         return; // Exit if no valid audioId
    //     }

    //     setIsDownloading(true);
    //     try {
    //         const response = await AudioHandler.doHandalGetDownloadAudio(audioId);
    //         const { status, data, error } = response;
    //         if (status == false || status == 400) {
    //             if (data.message == "Cancelled") {
    //             }
    //         }
    //         if (status && data) {
    //             doHandleDownloadingResourceAllocation(data);
    //         }

    //     } catch (error) {
    //         console.log(error);
    //     }
    // };

    const handleDownloadClick = async (e) => {
        if (audio?.audio?.url && audio?.audio?.fileName) {
            try {
                const response = await fetch(audio.audio.url);
                const blob = await response.blob();

                const blobUrl = window.URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = audio.audio.fileName;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // Clean up the object URL after download
                window.URL.revokeObjectURL(blobUrl);
            } catch (error) {
                console.error("Error downloading the audio file:", error);
            }
        } else {
            console.error("Audio URL or filename is missing!");
        }
    };



    const handleLoadedMetadata = (e) => {
        const audioDuration = e.target.duration;
        if (audioDuration && audioDuration !== Infinity && audioDuration !== NaN) {
            setDuration(audioDuration);
            setIsLoading(false);
        } else {
            // console.error('Failed to load audio metadata or duration is invalid.');
        }
    }

    const handleListen = (e) => {
        const currentTime = e.target.currentTime;
        const duration = e.target.duration;
        if (duration === Infinity) {
            setIsLoading(true)
        }
        if (duration && duration !== Infinity && currentTime >= 0) {
            const progressPercentage = (currentTime / duration) * 100;
            // setCurrentTime(currentTime);
            setProgressAriaAttributes(progressPercentage);
            setIsLoading(false)
        } else {
            // console.error('Invalid duration or metadata not loaded.');
        }
    };


    const setProgressAriaAttributes = (progressPercentage) => {
        if (progressPercentage >= 0 && progressPercentage <= 100) {
            const progressBar = document.querySelector('.rhap_progress-container');
            if (progressBar) {
                progressBar.setAttribute('aria-valuenow', Math.round(progressPercentage));
                progressBar.setAttribute('aria-valuemin', 0);
                progressBar.setAttribute('aria-valuemax', 100);
            }

            const indicator = document.querySelector('.rhap_progress-indicator');
            const filled = document.querySelector('.rhap_progress-filled');

            if (indicator) {
                indicator.style.left = `${progressPercentage}%`;
            }

            if (filled) {
                filled.style.width = `${progressPercentage}%`;
            }
        } else {
            console.error('Invalid progress percentage:', progressPercentage);
        }
    };

    const handlePlay = (e) => {
        const audioElement = e.target;
        setIsPlaying(true);

        // If metadata is not loaded, set a temporary duration to avoid blocking playback
        if (isLoading || duration === Infinity) {
            // setDuration(audioElement.duration);
            setIsLoading(true)
            setDuration(audio?.audio?.timeDuration)
        }
    };

    const handleCanPlay = () => {
        setIsLoading(false);
    };


    // Ensure metadata is loaded before allowing playback
    const handleMetadataAndPlay = (e) => {
        handleLoadedMetadata(e);
        if (!isLoading) {
            handlePlay(e);
        }
    };

    const handlePause = () => {
        setIsPlaying(false);
    };

    const handleEnd = () => {
        setIsPlaying(false);
        // setCurrentTime(duration);
    };



    // useEffect(() => {
    //     // Reset duration and current time when the audio changes
    //     setDuration(0);
    //     // setCurrentTime(0);
    //     setIsLoading(true); // Set loading state when audio changes

    // }, [audio]);

    // The notes live on the audio record, so the list and the player stay in step.
    const handleNotesChange = (update) => {
        const audioId = audio?._id;
        const apply = (el) => (el._id === audioId ? withNotes(el, update(audioNotes(el))) : el);

        setAudio((prevAudio) => (prevAudio && prevAudio._id === audioId ? apply(prevAudio) : prevAudio));
        setFilterAudioData((prevAudioData) => prevAudioData?.map(apply));
        setFavoriteAudio((prevAudioData) => prevAudioData?.map(apply));
    };

    const seekToSeconds = (seconds) => {
        const total = wavesurfer.current?.getDuration() || duration;
        if (wavesurfer.current && total > 0) {
            wavesurfer.current.seekTo(Math.max(0, Math.min(1, seconds / total)));
        }
    };

    const pausePlayback = () => {
        if (wavesurfer.current?.isPlaying()) {
            wavesurfer.current.pause();
        }
    };

    const handleVolumeChange = (e) => {
        const newVolume = parseFloat(e.target.value);
        setVolume(newVolume);
        if (wavesurfer.current) {
            wavesurfer.current.setVolume(newVolume); // Update Wavesurfer volume
        }
    };


    // Guards the seekbar gradient against a divide by zero before the file is measured
    const seekProgress = duration > 0 ? (currentTime / duration) * 100 : 0;
    const markTotal = duration || recordingSeconds(audio);

    const fileName = audio?.audio?.fileName;
    const extension = fileName?.includes(".")
        ? fileName.slice(fileName.lastIndexOf(".") + 1)
        : "";



    // The player has measured the real length; timeDuration is missing on uploads.
    const getAudioDurationInSeconds = (audio) => {
        const playerDuration = Number(duration);

        if (playerDuration && isFinite(playerDuration)) {
            return playerDuration;
        }

        return durationToSeconds(audio?.audio?.timeDuration);
    };

    // One job produces both the transcript and the summary, shown as tabs on the same screen.
    const startTranscriptionJob = async (audio) => {
        const transcribeId = audio?._id

        if (getAudioDurationInSeconds(audio) > TRANSCRIBE_MAX_DURATION) {
            errorToast("Audio longer than 30 minutes cannot be transcribed. Please trim the recording and try again.");
            return;
        }

        const stopStarting = () =>
            setTranscribeStartingIds((prevIds) => prevIds.filter((id) => id !== transcribeId));

        setTranscribeStartingIds((prevIds) =>
            prevIds.includes(transcribeId) ? prevIds : [...prevIds, transcribeId]
        );

        // Asked on this click, because a browser ignores a permission prompt without a user gesture.
        enablePushNotifications();

        try {
            // The file is already on the backend, so only its id is sent.
            const responseData = await AudioHandler.doHandalStartTranscribeAudio({
                audioId: transcribeId,
                uploadRequired: false,
            });

            if (responseData?.statusCode == 200) {
                // The job runs in the background and is picked up when the audio is opened again.
                setTranscribeInProgressIds((prevIds) =>
                    prevIds.includes(transcribeId) ? prevIds : [...prevIds, transcribeId]
                );
                stopStarting();
                // The modal belongs to this audio, so it is skipped once the user has moved on.
                if (currentAudioIdRef.current === transcribeId) {
                    setTranscribeModal(true);
                }
            }
            else if (responseData?.statusCode == 400 || responseData?.response?.data?.statusCode == 400 || responseData?.response?.status == 400) {
                errorToast("Transcription has failed as speech is not detected in the audio.");
                stopStarting()
            }
            else {
                console.error('Error in transcription:', responseData);
                errorToast(responseData?.response?.data?.message || "Unable to start the transcription. Please try again.");
                stopStarting()
            }
        } catch (error) {
            console.log(error, 'erro')
            const errorMessage =
                error?.response?.data?.error ||
                error?.response?.data?.message ||
                error?.message ||
                "An error occurred";
            errorToast(errorMessage)
            setTranscribeModal(false)
            stopStarting()
        }
    }

    const handleTranscribeAction = async (audio) => {
        // Already transcribed audio only has to be shown, never sent again.
        if (audio?.transcribe?.isTranscribe) {
            setTextAreaContent(audio?.transcribe?.transcribeText)
            setActionTabIndex(6);
            setSelectedTranscriptAudio(audio);
            return;
        }

        await startTranscriptionJob(audio);
    }

    useEffect(() => {
        // Only a different recording clears this, as the same one is re-set on every list refresh.
        setTranscribeModal(false);
    }, [audio?._id]);


    // AI Tools hands a saved recording over, so it is opened here.
    useEffect(() => {
        if (!handoffAudioId) {
            return;
        }

        const list = listTabIndex === 1 ? filterAudioData : favoriteAudio;
        const index = list?.findIndex((item) => item?._id === handoffAudioId);

        if (index === undefined || index < 0) {
            return;
        }

        // The played record is read off the index, so both are set until the selection sticks.
        if (audioIndex !== index || audio?._id !== handoffAudioId) {
            setAudioIndex(index);
            setSelectedAudioId(handoffAudioId);
            setAudio(list[index]);
            return;
        }

        // The modal only makes sense while the job it describes is running.
        if (isTranscribeInProgress) {
            setTranscribeModal(true);
        }

        setHandoffAudioId(null);
    }, [handoffAudioId, audio?._id, audioIndex, isTranscribeInProgress, filterAudioData, favoriteAudio, listTabIndex, setAudio, setAudioIndex, setSelectedAudioId, setHandoffAudioId]);


    return (
        <div className="vr-rd-root">
            {audio ? (
                <div className="vr-rd">
                    <div className="vr-card vr-rd-head">
                        <div className="vr-rd-id">
                            <span className="vr-icon-tile is-solid" role="img" aria-label="audio">
                                <Icon icon="lucide:audio-lines" width={22} height={22} />
                            </span>

                            <div className="vr-rd-title">
                                <h6>
                                    <span className="audio_fileName">
                                        {truncateFileName(audio?.audio?.fileName, 30)}
                                    </span>
                                </h6>
                                <div className="vr-rd-meta">
                                    <span className={`vr-rd-eq${isPlaying && !isLoading ? " is-on" : ""}`} aria-hidden="true"><i /><i /><i /></span>
                                    <span>{formatTimeWithOptionalHours(durationToSeconds(audio?.audio?.timeDuration))}</span>
                                    {extension && <span className="vr-badge vr-badge-primary">{extension}</span>}
                                </div>
                            </div>
                        </div>

                        <button
                            className="vr-btn vr-btn-secondary vr-rd-download"
                            onClick={(e) => handleDownloadClick(e)}
                            disabled={isInProgress}
                        >
                            {isDownloading ? (
                                <>
                                    <div>
                                        <span className="sr-only" style={{ marginRight: "7px" }}>
                                            Downloading
                                        </span>
                                        <span
                                            className="spinner-grow spinner-grow-sm"
                                            role="status"
                                            aria-hidden="true"
                                            style={{
                                                height: "0.5rem",
                                                width: "0.5rem",
                                                marginRight: "1px",
                                            }}
                                        ></span>
                                        <span
                                            className="spinner-grow spinner-grow-sm"
                                            role="status"
                                            aria-hidden="true"
                                            style={{
                                                height: "0.5rem",
                                                width: "0.5rem",
                                                marginRight: "1px",
                                            }}
                                        ></span>
                                        <span
                                            className="spinner-grow spinner-grow-sm"
                                            role="status"
                                            aria-hidden="true"
                                            style={{ height: "0.5rem", width: "0.5rem" }}
                                        ></span>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <Icon icon="lucide:download" width={18} height={18} aria-label="download" />
                                    <span>Download</span>
                                </>
                            )}
                        </button>
                    </div>

                    <AudioNote
                        audio={audio}
                        currentTime={currentTime}
                        isPlaying={isPlaying}
                        onSeek={seekToSeconds}
                        onPause={pausePlayback}
                        onNotesChange={handleNotesChange}
                    />

                    <div className="vr-rd-player">
                        <div className="vr-rd-volume">
                            <Icon icon="lucide:volume-2" width={18} height={18} aria-label="volume" />

                            <input
                                type="range"
                                // id="volume-control"
                                min="0"
                                max="1"
                                step="0.01"
                                value={volume}
                                onChange={(e) => handleVolumeChange(e)}
                                aria-label="volume"
                                className="volume-slider"
                                style={{
                                    background: `linear-gradient(to right, #334155 0%, #334155 ${volume * 100}%, #E4E6F0 ${volume * 100}%, #E4E6F0 100%)`,
                                }}
                            />
                        </div>

                        <div className="vr-rd-transport">
                            <button
                                type="button"
                                className={`vr-rd-ctl${isLoading || isPrevDisabled ? " is-disabled" : ""}`}
                                aria-label="prev"
                                aria-disabled={isLoading || isPrevDisabled}
                                onClick={!isLoading && !isPrevDisabled ? playPreviousTrack : undefined}
                            >
                                <Icon icon="lucide:skip-back" width={20} height={20} />
                            </button>
                            <button
                                type="button"
                                className={`vr-rd-ctl is-small${isLoading ? " is-disabled" : ""}`}
                                aria-label="backward"
                                aria-disabled={isLoading}
                                onClick={() => !isLoading ? handleSkip('backward') : undefined}
                            >
                                <Icon icon="tabler:rewind-backward-5" width={24} height={24} />
                            </button>
                            <div
                                className={`vr-rd-play${isLoading ? " is-loading" : ""}${isPlaying && !isLoading ? " is-playing" : ""}`}
                                role="button"
                                tabIndex={0}
                                aria-label={isPlaying ? "Pause Button" : "Play Button"}
                                aria-disabled={isLoading}
                                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") e.currentTarget.click(); }}
                                onClick={!isLoading ? playPause : undefined} // Disable click while loading
                            >
                                {isLoading ? (
                                    <div className="vr-rd-play-loader">
                                        <Loader />
                                    </div>
                                ) : (
                                    <Icon
                                        icon={isPlaying ? "ph:pause-fill" : "ph:play-fill"}
                                        className={isPlaying ? undefined : "vr-rd-play-icon"}
                                        width={30}
                                        height={30}
                                    />
                                )}
                            </div>
                            <button
                                type="button"
                                className={`vr-rd-ctl is-small${isLoading ? " is-disabled" : ""}`}
                                aria-label="forward"
                                aria-disabled={isLoading}
                                onClick={() => !isLoading ? handleSkip('forward') : undefined}
                            >
                                <Icon icon="tabler:rewind-forward-5" width={24} height={24} />
                            </button>
                            <button
                                type="button"
                                className={`vr-rd-ctl${isLoading || isNextDisabled ? " is-disabled" : ""}`}
                                aria-label="next"
                                aria-disabled={isLoading || isNextDisabled}
                                onClick={!isLoading && !isNextDisabled ? playNextTrack : undefined}
                            >
                                <Icon icon="lucide:skip-forward" width={20} height={20} />
                            </button>
                        </div>

                        <div className="vr-rd-timeline">
                            <span className="vr-rd-time is-current">{formatTimeWithOptionalHours(currentTime)}</span>
                            <div className="vr-rd-track">
                                <span className="vr-rd-rail" />
                                {/* Fill follows the thumb centre, which travels 8px in from each end */}
                                <span className="vr-rd-fill" style={{ width: `calc(8px + (100% - 16px) * ${seekProgress / 100})` }} />
                                {markTotal > 0 && audioNotes(audio).map((note) => (
                                    <span
                                        key={note._id}
                                        title={note.content}
                                        className="vr-rd-mark"
                                        style={{
                                            // Matches the thumb's travel, which stops half a thumb (8px) from each end.
                                            left: `calc(8px + (100% - 16px) * ${Math.min(1, noteSeconds(note) / markTotal)})`,
                                        }}
                                    />
                                ))}
                                <input
                                    ref={seekbarRef}
                                    type="range"
                                    min="0"
                                    max="100"
                                    defaultValue="0"
                                    onChange={handleSeekbarChange}
                                    aria-label="seek"
                                    className="seekbar vr-rd-seek"
                                />
                            </div>
                            <span className="vr-rd-time is-total">{formatTimeWithOptionalHours(duration)}</span>
                        </div>
                    </div>

                    <div className="vr-rd-toolbar-wrap">
                        <div className="vr-rd-toolbar">
                            <ActionButton
                                iconSrc="/img/dashboard/trim.png"
                                icon="lucide:scissors"
                                tone="cyan"
                                label="Trim"
                                onClick={() => {

                                    if (!isLoading && !transcribeLoading) {
                                        setActionTabIndex(3);
                                        setSelectedTrimAudio(audio);
                                    }



                                }}
                                isLoading={isLoading || transcribeLoading}

                            />
                            <ActionButton
                                iconSrc="/img/dashboard/adjust.svg"
                                icon="lucide:sliders-horizontal"
                                tone="blue"
                                label="Adjust"
                                onClick={() => {
                                    if (isCurrentUser?.isSubscriptionActive) {
                                        if (!isLoading && !transcribeLoading) {
                                            setActionTabIndex(7);
                                            setSelectedAdjustAudio(audio);
                                        }
                                    } else {
                                        navigate("/pricing")
                                    }
                                }}
                                isLoading={isLoading || transcribeLoading}
                            />
                            <ActionButton
                                iconSrc="/img/dashboard/merge.png"
                                icon="lucide:merge"
                                tone="violet"
                                label="Merge"
                                onClick={() => {
                                    if (isCurrentUser?.isSubscriptionActive) {
                                        if (!isLoading && !transcribeLoading) {
                                            setActionTabIndex(4);
                                            setSelectMergeAudio([audio]);
                                        }
                                    }
                                    else {
                                        navigate('/pricing')
                                    }

                                }}
                                isLoading={isLoading || transcribeLoading}

                            />
                            <ActionButton
                                iconSrc="/img/dashboard/convert.png"
                                icon="lucide:repeat"
                                tone="sky"
                                label="Convert"
                                onClick={() => {
                                    if (isCurrentUser?.isSubscriptionActive) {

                                        if (!isLoading && !transcribeLoading) {
                                            setActionTabIndex(5);
                                            setSelectedConvertAudio(audio);
                                        }
                                    } else {
                                        navigate("/pricing")
                                    }

                                }}
                                isLoading={isLoading || transcribeLoading}

                            />
                            <ActionButton
                                iconSrc="/img/dashboard/transcript.png"
                                iconImg="/img/dashboard/Transcribe.png"
                                tone="indigo"
                                label={transcribeLoading ? "Transcribing..." : (isTranscribeInProgress ? 'In progress' : 'Transcript & Summary')}
                                onClick={(e) => {
                                    if (isCurrentUser?.isSubscriptionActive) {
                                        if (!isLoading && !transcribeLoading) {
                                            handleTranscribeAction(audio)
                                        }
                                    } else {
                                        navigate("/pricing")
                                    }


                                }}
                                isLoading={isLoading || transcribeLoading}
                                transcribeLoading={transcribeLoading || isTranscribeInProgress}
                                disabled={isTranscribeInProgress}
                            />
                        </div>
                    </div>

                    {transcribeModal && (
                        <Modal
                            modaltxt={"Audio Transcription"}
                            btnnone
                        >
                            <div className="" >
                                <p className="vr-rd-modal-text">Transcription may take longer than 30 seconds. It will be saved with this recording and opens here once it is ready. </p>
                                <div className="vr-rd-modal-actions">
                                    <button className="vr-btn vr-btn-primary vr-btn-lg vr-btn-block"
                                        onClick={() => setTranscribeModal(false)}
                                    >OK</button>
                                </div>
                            </div>

                        </Modal>
                    )}
                </div>

            ) : (
                <>
                    <div className="vr-rd-empty">
                        <div className="vr-rd-empty-art">
                            <img src="/img/play_recording.png" alt="" />
                            <span className="vr-icon-tile is-solid">
                                <Icon icon="ph:play-fill" width={20} height={20} />
                            </span>
                        </div>
                        <h3>
                            Select Recording to Play
                        </h3>
                        <p>
                            Start recording a new audio by clicking the "Start Recording Now" button down below.
                        </p>
                        <a
                            className="vr-btn vr-btn-accent vr-btn-lg"
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") e.currentTarget.click(); }}
                            onClick={() => { setAutoStartRecording(true); setRecordingFolderId(tabIndex != "1" && tabIndex != "2" && tabIndex != "3" ? tabIndex : null); setTabIndex(1); setAudio(); setActionTabIndex(null); setRecordNew(false); }}
                        >
                            <Ic name="mic" />
                            Start Recording Now
                        </a>
                    </div>
                </>
            )}
        </div>
    );
};

const buttonStyle = {
    margin: '0 10px',
    padding: '5px 15px',
    backgroundColor: '#334155',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    height: '90px',
    width: '90px',
    cursor: 'pointer',
};

const seekbarStyle = {
    width: '100%',
    height: '10px',
    WebkitAppearance: 'none',
    // background: `linear-gradient(to right, #1e2b3c ${currentTime / duration * 100}%, #d3d3d3 ${currentTime / duration * 100}%)`,
    outline: 'none',
    opacity: '0.7',
    WebkitTransition: 'background 450ms ease-in',
    transition: 'background 450ms ease-in',
};

export default SelectRecordPlay;
